export default __webpack_public_path__ + "static/media/AutumnBook_04.25d9596d.png";